import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import axios from 'axios';
import Header from "../../components/layout/Header";
import PageTitle from "../../components/layout/PageTitle";
import NotFound from "../../assets/Images/not-found.png"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCode} from '@fortawesome/free-solid-svg-icons';
import BlogCard from "../../components/cards/BlogCard";
import WrapperBlog from "../../components/layout/WrapperBlog";
import Footer from "../../components/layout/Footer";
import {Helmet} from "react-helmet-async";
import { BLOG_API_BASE } from "../../utils/apiConfig";


const BlogList = () => {
    const [blogs, setBlogs] = useState([]);
    const [filteredBlogs, setFilteredBlogs] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0); // Store total pages
    const itemsPerPage = 12; // Number of blogs per page

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const response = await axios.get(BLOG_API_BASE, {
                    params: {
                        page: currentPage + 1, // Sending current page to API (starting from 1)
                        limit: itemsPerPage
                    }
                });

                if (response.data && Array.isArray(response.data.data)) {
                    setBlogs(response.data.data);
                    setFilteredBlogs(response.data.data);
                    setTotalPages(response.data.pagination.totalPages); // Set total pages
                } else {
                    console.error('Unexpected data structure:', response.data);
                    setBlogs([]);
                    setFilteredBlogs([]);
                    setTotalPages(0);
                }
            } catch (error) {
                console.error('There was a problem with the axios request:', error);
                setBlogs([]);
                setFilteredBlogs([]);
                setTotalPages(0);
            }
        };

        fetchBlogs();
    }, [currentPage]); // Re-fetch blogs when currentPage changes

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    const offset = currentPage * itemsPerPage;
    const currentBlogs = filteredBlogs.slice(offset, offset + itemsPerPage);

    return (
        <>
            <Helmet>
                <title>بلاگ کدپرو: مکانی برای شناخت بهتر دنیای کامپیوتر</title>
                <link rel="canonical" href='https://code-pro.ir/blog/'/>
                <meta name="description"
                      content="با کدپرو برنامه نویسی رو به روش حرفه‌ای یاد بگیر! از آخرین اخبار های برنامه نویسی و دنیای کامپیوتر باخبر شو!"/>
            </Helmet>
            <div className='min-h-screen flex flex-col'>
                <Header/>
                <main className='flex-1'>
                    <WrapperBlog className='my-10'>
                        {Array.isArray(currentBlogs) && currentBlogs.length > 0 ? (
                            <>
                                <div className="flex items-center mb-10 leading-4 lg:leading-2 px-3 md:px-1">
                                    <PageTitle title="بلاگ کدپرو: مکانی برای شناخت بهتر دنیای کامپیوتر به زبان فارسی"/>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 w-full">
                                    {currentBlogs.map(blogs => (
                                        <article key={blogs.id} className='my-4 mx-3'>
                                            <Link to={`/blog/${blogs.slug}/`}>
                                                <BlogCard blog={blogs}/>
                                            </Link>
                                        </article>
                                    ))}
                                </div>

                                <ReactPaginate
                                    previousLabel={'قبلی'}
                                    nextLabel={'بعدی'}
                                    breakLabel={'...'}
                                    pageCount={totalPages}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={handlePageClick}
                                    containerClassName={'pagination flex justify-center mt-4'}
                                    activeClassName={'active'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-link px-3 py-2 border rounded-md mx-3'}
                                    previousClassName={'page-item'}
                                    previousLinkClassName={'page-link px-3 py-2 border rounded-md mx-3'}
                                    nextClassName={'page-item'}
                                    nextLinkClassName={'page-link px-3 py-2 border rounded-md mx-3'}
                                    breakClassName={'page-item'}
                                    breakLinkClassName={'page-link px-3 py-2 border rounded-md mx-3'}
                                />
                            </>
                        ) : (
                            <div className='w-full relative mb-20'>
                                <img src={NotFound} alt='Article not found' className='w-1/2 m-auto'/>
                                <p className='text-3xl text-center my-5'>هیچ مقاله ای پیدا نشد...</p>
                            </div>
                        )}
                    </WrapperBlog>
                </main>
                <Footer/>
            </div>
        </>
    );
};

export default BlogList;
